/* eslint-disable import/no-anonymous-default-export */
import config from "../config";

export default {
  "intro.video": {
    maharashtra: {
      video: `https://www.youtube-nocookie.com/embed/ydEbHbaLK18?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=mr`,
      background: `${config.gcpBucketBase}content%2Fvideos%2Fintro%2Fintro_maharashtra.jpg?alt=media`,
    },
    gujarat: {
      video: `https://www.youtube-nocookie.com/embed/lnatbRljflk?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=gu`,
      background: `${config.gcpBucketBase}content%2Fvideos%2Fintro%2Fintro_gujarat.jpg?alt=media`,
    },
    rajasthan: {
      video: `https://www.youtube-nocookie.com/embed/ExQnMqszX_I?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=hi`,
      background: `${config.gcpBucketBase}content%2Fvideos%2Fintro%2Fintro_rajasthan.jpg?alt=media`,
    },
    "madhya pradesh": {
      video: `https://www.youtube-nocookie.com/embed/Yade1Ucum08?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=hi`,
      background: `${config.gcpBucketBase}content%2Fvideos%2Fintro%2Fintro_rajasthan.jpg?alt=media`,
    },
    "uttar pradesh": {
      video: `https://www.youtube-nocookie.com/embed/VrPNWmm0ve4?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=hi`,
      background: `${config.gcpBucketBase}content%2Fvideos%2Fintro%2Fintro_rajasthan.jpg?alt=media`,
    },
  },
  "dashboard.banner": {
    mr: {
      background: `${config.gcpBucketBase}content%2Fimages%2Fwebapp%2Fdashboard%2Fdashboard-banner-mr.jpeg?alt=media`,
    },
    gu: {
      background: `${config.gcpBucketBase}content%2Fimages%2Fwebapp%2Fdashboard%2Fdashboard-banner-gu.jpeg?alt=media`,
    },
    hi: {
      background: `${config.gcpBucketBase}content%2Fimages%2Fwebapp%2Fdashboard%2Fdashboard-banner-hi.jpeg?alt=media`,
    },
    en: {
      background: `${config.gcpBucketBase}content%2Fimages%2Fwebapp%2Fdashboard%2Fdashboard-banner-en.jpeg?alt=media`,
    },
  },
  "howToUse.video": {
    maharashtra: {
      video: `https://www.youtube-nocookie.com/embed/hr8t11vcD7I?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=mr`,
      background: `${config.gcpBucketBase}content%2Fvideos%2Fintro%2Fintro_maharashtra.jpg?alt=media`,
    },
    gujarat: {
      video: `https://www.youtube-nocookie.com/embed/hr8t11vcD7I?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=gu`,
      background: `${config.gcpBucketBase}content%2Fvideos%2Fintro%2Fintro_gujarat.jpg?alt=media`,
    },
    rajasthan: {
      video: `https://www.youtube-nocookie.com/embed/hr8t11vcD7I?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=hi`,
      background: `${config.gcpBucketBase}content%2Fvideos%2Fintro%2Fintro_rajasthan.jpg?alt=media`,
    },
    "madhya pradesh": {
      video: `https://www.youtube-nocookie.com/embed/hr8t11vcD7I?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=hi`,
      background: `${config.gcpBucketBase}content%2Fvideos%2Fintro%2Fintro_rajasthan.jpg?alt=media`,
    },
    "uttar pradesh": {
      video: `https://www.youtube-nocookie.com/embed/hr8t11vcD7I?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=hi`,
      background: `${config.gcpBucketBase}content%2Fvideos%2Fintro%2Fintro_rajasthan.jpg?alt=media`,
    },
  },
  "success.video": {
    maharashtra: {
      watermelon: {
        video: `https://www.youtube-nocookie.com/embed/AMT_3M2Q7V0?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=mr`,
        background: `${config.gcpBucketBase}content%2Fvideos%2Fsuccess%2Fsuccess_banana_maharashtra.jpg?alt=media`,
      },
      gram: {
        video: `https://www.youtube-nocookie.com/embed/XL1I9-e0bHk?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=mr`,
        background: `${config.gcpBucketBase}content%2Fvideos%2Fsuccess%2Fsuccess_brinjal_maharashtra.jpg?alt=media`,
      },
      onion: {
        video: `https://www.youtube-nocookie.com/embed/G4IDWsO_1cE?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=mr`,
        background: `${config.gcpBucketBase}content%2Fvideos%2Fsuccess%2Fsuccess_chilli_maharashtra.jpg?alt=media`,
      },
    },
    gujarat: {
      "all crops": {
        video: `https://www.youtube-nocookie.com/embed/BgvGAFiVTs0?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=gu`,
        background: `${config.gcpBucketBase}content%2Fvideos%2Fsuccess%2Fsuccess_cotton_gujarat.jpg?alt=media`,
      },
      cumin: {
        video: `https://www.youtube-nocookie.com/embed/2qpfBHZ-1Y4?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=gu`,
        background: `${config.gcpBucketBase}content%2Fvideos%2Fsuccess%2Fsuccess_cumin_gujarat.jpg?alt=media`,
      },
      cotton: {
        video: `https://www.youtube-nocookie.com/embed/eB2OPRQGaQw?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=gu`,
        background: `${config.gcpBucketBase}content%2Fvideos%2Fsuccess%2Fsuccess_cumin_gujarat.jpg?alt=media`,
      },
    },
    rajasthan: {
      "all crops": {
        video: `https://www.youtube-nocookie.com/embed/GdXaIPWasRM?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=hi`,
        background: `${config.gcpBucketBase}content%2Fvideos%2Fsuccess%2Fsuccess_cotton_rajasthan.jpg?alt=media`,
      },
      watermelon: {
        video: `https://www.youtube-nocookie.com/embed/wbNLtMxv2gk?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=hi`,
        background: `${config.gcpBucketBase}content%2Fvideos%2Fsuccess%2Fsuccess_watermelon_rajasthan.jpg?alt=media`,
      },
      cotton: {
        video: `https://www.youtube-nocookie.com/embed/z8S0LBHJjaQ?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=hi`,
        background: `${config.gcpBucketBase}content%2Fvideos%2Fsuccess%2Fsuccess_watermelon_rajasthan.jpg?alt=media`,
      },
    },
    "madhya pradesh": {
      "all crops": {
        video: `https://www.youtube-nocookie.com/embed/GdXaIPWasRM?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=hi`,
        background: `${config.gcpBucketBase}content%2Fvideos%2Fsuccess%2Fsuccess_cotton_rajasthan.jpg?alt=media`,
      },
      watermelon: {
        video: `https://www.youtube-nocookie.com/embed/wbNLtMxv2gk?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=hi`,
        background: `${config.gcpBucketBase}content%2Fvideos%2Fsuccess%2Fsuccess_watermelon_rajasthan.jpg?alt=media`,
      },
      cotton: {
        video: `https://www.youtube-nocookie.com/embed/z8S0LBHJjaQ?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=hi`,
        background: `${config.gcpBucketBase}content%2Fvideos%2Fsuccess%2Fsuccess_watermelon_rajasthan.jpg?alt=media`,
      },
    },
    "uttar pradesh": {
      "all crops": {
        video: `https://www.youtube-nocookie.com/embed/GdXaIPWasRM?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=hi`,
        background: `${config.gcpBucketBase}content%2Fvideos%2Fsuccess%2Fsuccess_cotton_rajasthan.jpg?alt=media`,
      },
      watermelon: {
        video: `https://www.youtube-nocookie.com/embed/wbNLtMxv2gk?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=hi`,
        background: `${config.gcpBucketBase}content%2Fvideos%2Fsuccess%2Fsuccess_watermelon_rajasthan.jpg?alt=media`,
      },
      cotton: {
        video: `https://www.youtube-nocookie.com/embed/z8S0LBHJjaQ?autoplay=0&rel=0&modestbranding=1&enablejsapi=1&frameborder=0&hl=hi`,
        background: `${config.gcpBucketBase}content%2Fvideos%2Fsuccess%2Fsuccess_watermelon_rajasthan.jpg?alt=media`,
      },
    },
  },
};
